/** Shared muted overlay styles (TO preview / hidden-from-client fields). */
export const agencyMutedLabelClass = 'text-gray-500';

/** Gray read-only field shell (background only — text styled separately). */
export const agencyMutedFieldBoxClass =
  'w-full rounded-lg border border-gray-300 bg-gray-100 px-3 py-2 whitespace-pre-wrap';

/** Text inside muted content boxes — 16px, same as read-only paragraphs. */
export const agencyMutedFieldContentClass = 'text-base text-gray-900';
